var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1666 12.3802C15.4949 12.2357 14.9635 12.5475 14.493 12.8199C14.0111 13.1006 13.0949 13.8438 12.5697 13.6536C9.88084 12.5465 7.35189 10.193 6.25714 7.49335C6.0642 6.95695 6.804 6.03489 7.08259 5.54735C7.35292 5.0754 7.65833 4.53901 7.51904 3.86227C7.39316 3.25415 5.76497 1.18236 5.18923 0.61582C4.80952 0.241589 4.42053 0.0357622 4.02123 0.00249721C2.51995 -0.0619537 0.843272 1.94122 0.549208 2.42044C-0.187499 3.4423 -0.183372 4.80201 0.56159 6.4507C2.35693 10.8791 9.14723 17.5622 13.5922 19.4251C14.4125 19.8087 15.1626 20.001 15.8364 20.001C16.4957 20.001 17.0828 19.817 17.5874 19.4521C17.9681 19.2328 20.0534 17.4728 19.9987 15.9312C19.9657 15.5383 19.7604 15.1453 19.391 14.7649C18.8286 14.1838 16.7702 12.507 16.1666 12.3802Z",
    fill: "#FFAB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneYellow);
export default __webpack_public_path__ + "static/media/phoneYellow.41c5d975.svg";
export { ForwardRef as ReactComponent };